import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

// Create axios instance
const api = axios.create({
    headers: {
        'Content-Type': 'application/json'
    }
});

// Add a request interceptor to include JWT token
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Add a response interceptor to handle 401 errors (token expired)
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && error.response.status === 401) {
            // Auto logout if 401 response returned from api
            localStorage.removeItem('user');
            localStorage.removeItem('token');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

// Submission CRUD operations
export const getSubmissions = async () => {
    const response = await api.get(`${API_URL}/submissions`);
    return response.data;
};

export const getSubmissionById = async (id) => {
    const response = await api.get(`${API_URL}/submissions/${id}`);
    return response.data;
};

export const getSubmissionsByFormId = async (formId) => {
    const response = await api.get(`${API_URL}/submissions/form/${formId}`);
    return response.data;
};

export const createSubmission = async (submissionData) => {
    const response = await api.post(`${API_URL}/submissions`, submissionData);
    return response.data;
};

export const updateSubmission = async (id, submissionData) => {
    const response = await api.put(`${API_URL}/submissions/${id}`, submissionData);
    return response.data;
};

export const deleteSubmission = async (id) => {
    const response = await api.delete(`${API_URL}/submissions/${id}`);
    return response.data;
};

export const updateSubmissionStatus = async (id, status) => {
    const response = await api.patch(`${API_URL}/submissions/${id}/status`, { status });
    return response.data;
};

export const searchSubmissions = async (queryParams) => {
    // Convert query params object to URL query string
    const queryString = new URLSearchParams(queryParams).toString();
    const response = await api.get(`${API_URL}/submissions/search/query?${queryString}`);
    return response.data;
};

// Utility function for submission statuses
export const getSubmissionStatuses = () => {
    return [
        { value: 'pending', label: 'Pending' },
        { value: 'approved', label: 'Approved' },
        { value: 'rejected', label: 'Rejected' },
        { value: 'suspicious', label: 'Suspicious' }
    ];
};